// @ts-expect-error Untyped module
import SocialComposerPanel from 'social-composer-lib/components/SocialComposerPanel';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { jsx as _jsx } from "react/jsx-runtime";
const SocialComposerPanelWrapper = ({
  onClose,
  crmObjects: [crmObject]
}) => {
  const absoluteUrl = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.ABSOLUTE_URL);
  const htmlTitle = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.HTML_TITLE);
  const name = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.NAME);
  // TODO: pass actual value through when the CMP BE returns this property
  // const campaignId = getContentPropertyValue(
  //   crmObject,
  //   CONTENT_PLATFORM_PROPERTY_NAME.CAMPAIGN_ID
  // );

  return /*#__PURE__*/_jsx(SocialComposerPanel, {
    clientTag: "content-detail-ui",
    onCloseModal: onClose,
    open: true,
    body: htmlTitle || name,
    link: absoluteUrl,
    remoteContentType: "blog-post",
    remoteContentId: `${crmObject.objectId}`
    // campaignGuid={campaignId}
  });
};
export default SocialComposerPanelWrapper;